class classCheckbox {
    constructor(checked, disabled = false, error = false, message = "", show) {
        this.checked = checked;
        this.disabled = disabled;
        this.message = message;
        this.error = error;
        this.show = show;
    }
};
export default classCheckbox;